<template>
    <div class="d-flex flex-row flex-column-fluid page">
        <!--begin::Aside-->
        <Aside></Aside>
        <!--end::Aside-->
        <div class="d-flex flex-column flex-row-fluid wrapper pt-0" id="kt_wrapper">
            <div class="d-flex flex-column" style="min-height: 100vh;">
                <Toasts :firebase-uid="$page.props.auth_uid"/>

                <div class="p-8">
                    <Card>
                        <template v-slot:icon>
                            <i class="fas fa-chart-pie font-size-h2"/>
                        </template>
                        <template v-slot:title>
                            {{ __('orders.statistics_overview') }}
                        </template>
                        <template v-slot:description>
                            {{ __('orders.statistics_overview_subtitle') }}
                        </template>
                        <FilterBar class="mt-n2 mb-n2">
                            <!-- DATE -->
                            <FilterDateRange v-model="filters.date"/>

                            <!-- STORES -->
                            <FilterStores :stores="stores"
                                          v-model="filters.stores"
                            />

                            <!-- INTEGRATIONS / SALES CHANNELS -->
                            <FilterSalesChannels :sales-channel-integrations="integrations"
                                                 v-model="filters.integrations"
                            />
                        </FilterBar>
                    </Card>

                    <TabbedOrderStatisticsCard :tab-init="initTab" :key="initTab" :filters="filters">
                        <slot/>
                    </TabbedOrderStatisticsCard>

                    <PageFooter/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FilterSalesChannels from '@components/Stats/Filters/FilterSalesChannels.vue';
import Card from '@components/Cards/Card.vue';
import FilterStores from '@components/Stats/Filters/FilterStores.vue';
import FilterBar from '@components/Stats/FilterBar.vue';
import FilterDateRange from '@components/Stats/Filters/FilterDateRange.vue';
import TabbedOrderStatisticsCard from '@components/Stats/TabbedOrderStatisticsCard.vue';
import {rewriteUrlNew} from '@composables/rewriteUrlNew';
import Toasts from '@components/Toasts.vue';
import PageFooter from '@layouts/Includes/PageFooter.vue';
import Aside from '@components/Navigation/Aside.vue';

export default {
    components: {
        Aside,
        PageFooter,
        Toasts,
        TabbedOrderStatisticsCard,
        FilterDateRange,
        FilterBar,
        FilterStores,
        Card,
        FilterSalesChannels,
    },

    props: {
        stores: Object,
        integrations: Array,
        statistics: {
            types: [Object, Array],
        },
        initTab: {
            type: String,
            default: 'overview',
        },
        initFilters: {
            type: Object,
            default() {
                return {
                    date: {},
                    stores: {},
                    integrations: {},
                };
            },
        },
    },

    data() {
        return {
            filters: this.initFilters,
        };
    },

    methods: {
        fetchData(...params) {
            this.$inertia.reload({only: ['initFilters', 'initTab', 'statistics']});
        },
    },

    watch: {
        filters: {
            deep: true,
            handler(newValue, oldValue) {
                rewriteUrlNew('filter', newValue);
                this.fetchData();
            },
        },
    },
};
</script>
